module.exports = __webpack_public_path__ + "img/director-test-icon8.6f48da22.png";